import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import TabText from "./tabText";
import { useMediaQuery } from "@mui/material";
import LevelTab from "./level-tab";
import AppButton from "../app-button";
import PlatformBox from "../platform-box";
const sxStyles = {
  mainContainer: {
    display: "flex",
    backgroundColor: "#070505",
    minHeight: "1103px",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    flexGrow: 1,
    overflow: "hidden",
    position: "relative",
  },
  content: {
    display: "flex",
    width: { xs: "100%", xl: "1440px" },
    maxWidth: "1440px",
    justifyContent: "center",
    alignItems: "center",
    padding: { xs: "0px 30px", lg: "0px 0px" },
  },
  textContainer: {
    backgroundColor: "#170620",
    borderColor: "#540A8D",
    borderWidth: "1px",
    borderStyle: "solid",
    minHeight: "442px",
    height: "auto",
    maxWidth: { xs: "100%", md: "1100px" },
    padding: { xs: "70px 30px", md: "50px", lg: "135px 127px 100px 127px" },
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  title: {
    color: "white",
    fontSize: { xs: "40px", md: "64px" },
    lineHeight: { xs: "40px", md: "64px" },
    fontWeight: "400",
    fontFamily: "IBM Plex Sans",
  },
  titleP22: {
    color: "white",
    fontSize: { xs: "40px", md: "64px" },
    lineHeight: { xs: "40px", md: "64px" },
    fontWeight: "700",
    fontFamily: "p22-arts-and-crafts",
    marginLeft: "10px",
    marginRight: "10px",
  },
  sectionText: {
    color: "white",
    fontSize: { xs: "20px", md: "20px" },
    lineHeight: { xs: "28px", md: "22px" },
    fontWeight: "400",
    fontFamily: "IBM Plex Sans",
    marginBottom: "50px",
    textAlign: "center",
    width: { xs: "330px", md: "820px" },
  },
};

const levels: Record<string, Array<string>> = {
  one: [
    "Recibirán 1 sobre de forma gratuita por acceder al nivel. ",
    "Recibirán 1 sobre extra por cada Session que completes.",
    "Accederán al canal Discord Nivel 1 para participar de desafíos y retos donde se regalan cards y otros premios.",
  ],
  two: [
    "Recibirán 2 sobres de forma gratuita por acceder al nivel.",
    "Recibirán 2 sobres por cada session que completen.",
    "Acceso al canal de Discord Nivel 2, concursos especiales" +
      " para ganar cards y más actividades y beneficios.",
    "Concursos para ganar entradas de distintas categorías" +
      " y upgrade de entradas, sujeto a disponibilidad y agenda del artista.",
  ],
  three: [
    "Recibirán 5 sobres de forma gratuita por llegar a este nivel.",
    " Este nivel también cuenta con un canal de Discord Nivel 3, en el cual ofreceremos" +
      " live streams exclusivos, desafíos y premios. ",
    "Concursos para ganar entradas de distintas categorías y upgrade de entradas.",
  ],
  four: [
    "Acceso al Discord exclusivo del Nivel 4 Modo GOD, el nivel más alto de fandom.",
    "Acceso al Concurso Mixer de cada una de las sessions que cuenten con esta función.",
    "Acceso a concursos para ganar Posters firmados por BZRP.",
    " El primero que logre completar el álbum tendrá un premio especial (*).",
    "Para el resto que llegue a Nivel 4 habrá concursos para participar y ganar " +
      "la posibilidad de acudir a un show de BZRP en el mundo. " +
      "El plazo de tiempo para lograr participar de este concurso " +
      "será para quienes completen el 100% del album " +
      "antes del 30 de junio de 2024 (**)",
    "(*) Premio para el 1ro que llene el Album: 2 entradas para\n" +
      "                      un show de BZRP. 4 Sagas físicas impresas con todas sus\n" +
      "                      cards. 1 Wallpaper (**) Premio para el ganador del\n" +
      "                      concurso de quienes logren llenar las 4 Sagas 1 viaje para\n" +
      "                      el ganador a un show del BZRP en el mundo. 4 Sagas físicas\n" +
      "                      impresas con todas sus cards.",
  ],
};
const CollectionSection = () => {
  const [currentTab, setCurrentTab] = React.useState<string>("one");
  const handleChange = (level: string) => {
    setCurrentTab(level);
  };

  const isMobile = useMediaQuery("(max-width: 899px)");

  const tabs = isMobile
    ? [
        { value: "one", label: "1" },
        { value: "two", label: "2" },
        { value: "three", label: "3" },
        { value: "four", label: "4" },
      ]
    : [
        { value: "one", label: "Nivel 1" },
        { value: "two", label: "Nivel 2" },
        { value: "three", label: "Nivel 3" },
        { value: "four", label: "Nivel 4" },
      ];

  return (
    <Stack sx={sxStyles.mainContainer} id={"collection-section"}>
      <Stack sx={sxStyles.content}>
        <Grid
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "center",
            marginTop: "112px",
            marginBottom: "30px",
          }}
        >
          <Typography sx={sxStyles.title}>LLEVA TU</Typography>
          <Typography sx={sxStyles.titleP22}>COLECCION</Typography>
          <Typography sx={sxStyles.title}>A OTRO NIVEL</Typography>
        </Grid>
        <Typography sx={sxStyles.sectionText}>
          Sube de Nivel interactuando con la aplicación, completando Sagas y
          participando de la Comunidad. Accede a diferentes premios y
          beneficios, tanto digitales como en la vida real.
        </Typography>
        <Box
          sx={{
            marginBottom: "110px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <PlatformBox />
          {/*<AppButton bgColor={"#FED301"} color={"black"} />*/}
        </Box>
        <Typography
          color={"secondary"}
          sx={{
            fontSize: "32px",
            display: { xs: "block", md: "none" },
            marginBottom: "36px",
          }}
        >
          NIVELES
        </Typography>
        <Box
          sx={{
            marginBottom: "40px",
            display: "flex",
            width: { xs: "100%", md: "fit-content" },
            justifyContent: { xs: "space-evenly", md: "space-between" },
            alignItems: "center",
            flexDirection: "row",
          }}
        >
          {tabs.map((tab, index) => {
            return (
              <LevelTab
                key={tab.value}
                value={tab.value}
                label={tab.label}
                current={currentTab}
                onPress={handleChange}
                totalTabs={tabs.length}
                index={index}
              />
            );
          })}
        </Box>
        <Box sx={sxStyles.textContainer}>
          <Grid
            columns={{ xs: 1, md: 12 }}
            columnSpacing={{ xs: 0, md: "64px" }}
            container
            sx={{ maxWidth: "100%" }}
          >
            {levels[currentTab].map((info, index) => {
              return (
                <Grid item key={`${levels[currentTab]}-${index}`} xs={1} md={6}>
                  <TabText arrowText={info} />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Stack>
    </Stack>
  );
};

export default CollectionSection;
